function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#7F63FF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.25 2.5v-2a.5.5 0 10-1 0v2h-2.5v2.29h4.5V2.5h-1z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 4.79V35.5h13.5V4.79h-13.5zm10.5 26.93h-7.5a.5.5 0 110-1h7.5a.5.5 0 110 1zm0-4.5h-7.5a.5.5 0 110-1h7.5a.5.5 0 110 1zm0-4.5h-7.5a.5.5 0 110-1h7.5a.5.5 0 110 1zm0-4.5h-7.5a.5.5 0 110-1h7.5a.5.5 0 110 1zm0-4.5h-7.5a.5.5 0 110-1h7.5a.5.5 0 110 1zm0-4.5h-7.5a.5.5 0 110-1h7.5a.5.5 0 110 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.83 17.22h6.42v-4H9.76v-2.28a.745.745 0 10-1.49 0v2.23h-6V35.5h8.93v-3.78H4.83a.5.5 0 110-1h6.42v-3.5H4.83a.5.5 0 110-1h6.42v-3.5H4.83a.5.5 0 110-1h6.42v-3.5H4.83a.5.5 0 110-1zM32.1 13.17v-2.23a.745.745 0 00-1.49 0v2.23h-6V35.5h8.93V13.17H32.1zm-.93 18.55h-6.42v-1h6.42a.5.5 0 110 1zm0-4.5h-6.42v-1h6.42a.5.5 0 110 1zm0-4.5h-6.42v-1h6.42a.5.5 0 110 1zm0-4.5h-6.42v-1h6.42a.5.5 0 110 1z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 35h36.03v1H0z"
}));

function SvgBusinessIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 37 36"
  }, props), _ref);
}

export default __webpack_public_path__ + "90adf14257513d642221664d72ef47fd.svg";
export { SvgBusinessIc as ReactComponent };